import styles from "./OutageInfoPopup.scss";
import { getLocalizedStrings } from "./popupLocalizedStrings";


function OutageInfoPopup(props) {

  let repairStrings = getLocalizedStrings("RepairMaintenanceAlerts");
  
  return (
    <div>
      <div className={styles.popUp}>
        <div className={styles.popupContent}>
          {props.infoPopupTxt}
        </div>
      </div>
    </div>
  );
}

export default OutageInfoPopup;